import { type ApiEnvelope, api, unwrap } from "@/lib/api";

import type {
	Driver,
	Hub,
	LogisticsKpi,
	ShipmentListParams,
	ShipmentListResponse,
	Tour,
	TourStatus,
} from "./types";

function shipmentParams(p: ShipmentListParams): URLSearchParams {
	const usp = new URLSearchParams();
	if (p.hub) usp.append("hub", p.hub);
	if (p.status) usp.append("status", p.status);
	if (p.slaOverdue) usp.append("sla_overdue", "true");
	if (p.page) usp.append("page", String(p.page));
	if (p.pageSize) usp.append("pageSize", String(p.pageSize));
	return usp;
}

export const logisticsApi = {
	shipments: (params: ShipmentListParams = {}) =>
		unwrap<ShipmentListResponse>(
			api.get<ApiEnvelope<ShipmentListResponse>>(
				`/admin/logistics/shipments?${shipmentParams(params).toString()}`,
			),
		),

	tours: (filter: { hub?: string; status?: TourStatus } = {}) => {
		const usp = new URLSearchParams();
		if (filter.hub) usp.append("hub", filter.hub);
		if (filter.status) usp.append("status", filter.status);
		return unwrap<Tour[]>(
			api.get<ApiEnvelope<Tour[]>>(`/admin/logistics/tours?${usp.toString()}`),
		);
	},

	tourDetail: (id: string) =>
		unwrap<Tour>(api.get<ApiEnvelope<Tour>>(`/admin/logistics/tours/${id}`)),

	drivers: (filter: { hub?: string; type?: string; status?: string } = {}) => {
		const usp = new URLSearchParams();
		if (filter.hub) usp.append("hub", filter.hub);
		if (filter.type) usp.append("type", filter.type);
		if (filter.status) usp.append("status", filter.status);
		return unwrap<Driver[]>(
			api.get<ApiEnvelope<Driver[]>>(
				`/admin/logistics/drivers?${usp.toString()}`,
			),
		);
	},

	kpi: (params: { from?: string; to?: string; hub?: string } = {}) => {
		const usp = new URLSearchParams();
		if (params.from) usp.append("from", params.from);
		if (params.to) usp.append("to", params.to);
		if (params.hub) usp.append("hub", params.hub);
		return unwrap<LogisticsKpi>(
			api.get<ApiEnvelope<LogisticsKpi>>(
				`/admin/logistics/kpi?${usp.toString()}`,
			),
		);
	},

	hubs: () => unwrap<Hub[]>(api.get<ApiEnvelope<Hub[]>>(`/admin/catalog/hubs`)),
};
